<template>
    <div>
        <h1>Usuarios</h1>
        <v-btn 
        fab dark x-large elevation="8" 
        color="primary" 
        fixed right bottom
        to="/panel/nuevo-usuario">
        <v-icon dark>add</v-icon>
        </v-btn>

        <v-data-table
        :loading="cargando"
        :headers="encabezadoTabla"
        :items="usuarios"
        sort-by="nombre"
        class="elevation-1"
        :footer-props="{itemsPerPageText: 'Por página'}"
        >
        <template v-slot:[`item.opciones`]="{ item }">
            <v-icon
                color="blue"
                class="mr-2"
                @click="editar(item.id)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                color="red"
                @click="eliminar(item)"
            >
                mdi-delete
            </v-icon>
            </template>
        </v-data-table>
        <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
            <dialogo-eliminar :nombre="itemSeleccionado" @cancelar="cerrarDialogoEliminar" @eliminar="confirmarEliminar"/>
        </v-dialog>
        <v-snackbar
        v-model="mostrarMensaje"
        :timeout="3000"
        :color="mensaje.color"
        top
        >
            {{ mensaje.texto }}
        </v-snackbar>
    </div>
</template>
<script>
import ApiService from '../../Servicios/ApiService'
import DialogoEliminar from '../Dialogos/DialogoEliminar.vue'

export default {
    name: "Usuarios",
    components: { DialogoEliminar },

    data: () => ({
        cargando: false,
        mostrarDialogoEliminar: false,
        usuario: {},
        usuarios: [],
        encabezadoTabla: [
            { text: "Usuario",  sortable: true, value: "usuario" },
            { text: "Nombre",   sortable: true, value: "nombre" },
            { text: "Teléfono", value: "telefono" },
            { text: "Rol",      value: "rol" },
            { text: "Opciones", value: "opciones", sortable: false },
        ],
        itemSeleccionado: "",
        mensaje: { texto: "", color: "" },
        mostrarMensaje: false
    }),

    mounted () {
        this.obtenerUsuarios()
    },

    methods: {
        editar (id) {
            this.$router.push({ name: 'EditarUsuario', params: { id } })
        },

        eliminar (usuario) {
            this.itemSeleccionado = usuario.nombre
            this.usuario = usuario
            this.mostrarDialogoEliminar = true
        },

        cerrarDialogoEliminar () {
            this.mostrarDialogoEliminar = false
            this.usuario = {}
        },

        async confirmarEliminar () {
            this.cargando = true
            try {
                await ApiService.delete(`api/panel/usuarios/${this.usuario.id}`)
                this.mostrarDialogoEliminar = false
                this.mostrarMensaje = true
                this.mensaje = { texto: 'Usuario dado de baja', color: 'success' }
                this.obtenerUsuarios()
            } catch (err) {
                console.error('Error al eliminar usuario:', err)
                this.mostrarMensaje = true
                this.mensaje = { texto: 'Error al dar de baja el usuario', color: 'error' }
            } finally {
                this.cargando = false
            }
        },

        async obtenerUsuarios () {
            this.cargando = true
            try {
                const data = await ApiService.get('api/panel/usuarios')
                this.usuarios = Array.isArray(data) ? data : (data.usuarios || [])
            } catch (err) {
                console.error('Error al obtener usuarios:', err)
            } finally {
                this.cargando = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Usuarios/Usuarios.vue